import { LinearGradient } from 'expo-linear-gradient';
import React from 'react';
import { ActivityIndicator, Pressable, PressableProps, Text, View } from 'react-native';

import { ButtonProps, SIZES } from './index';

import { getIconByName } from 'components/Icons';

type GradientButtonProps = Omit<ButtonProps, 'variant'>;

const GRADIENT_COLORS = {
  primary: ['#153c8e', '#194173', '#183954', '#142c44'],
  secondary: ['#19285e', '#1e2c5e', '#293360', '#353d60'],
  newBtnColors: ['#17b56e', '#4adc9a', '#17b56e', '#4adc9a'],
};

const GradientButton = React.forwardRef<PressableProps, GradientButtonProps>(
  (
    {
      children,
      gradientVariant = 'primary',
      iconStyle,
      iconType,
      isFullWidth = false,
      isLoading = false,
      size = 'md',
      style,
      textStyle,
      textTransform,
      rounded = false,
      ...rest
    },
    ref
  ) => {
    const Icon = iconType ? getIconByName(iconType) : null;

    return (
      <LinearGradient
        colors={GRADIENT_COLORS[gradientVariant]}
        start={{ x: 0.1, y: 0.1 }}
        end={{ x: 1, y: 0.1 }}
        locations={[0.1, 0.2, 0.5, 1]}
        style={{
          borderRadius: 5,
          width: isFullWidth ? '100%' : undefined,
          borderColor: 'white',
        }}>
        <Pressable
          role="button"
          ref={ref}
          style={[
            {
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              paddingHorizontal: 20,
            },
            style,
          ]}
          {...rest}>
          {Icon && (
            <View style={{ marginRight: 4 }}>
              <Icon {...iconStyle} />
            </View>
          )}
          {children && (
            <Text
              style={[
                {
                  fontFamily: 'system-ui',
                  fontSize: SIZES[size],
                  fontWeight: 600,
                  color: 'white',
                  lineHeight: 22,
                  textTransform,
                },
                textStyle,
              ]}>
              {children}
            </Text>
          )}
          {isLoading && <ActivityIndicator color="white" size="small" style={{ marginLeft: 4 }} />}
        </Pressable>
      </LinearGradient>
    );
  }
);

export default GradientButton;
